__turbopack_context__.v({
  "container": "InscriptionText-module__82l4uq__container",
  "root": "InscriptionText-module__82l4uq__root",
});
